
$(document).ready(function() {
    function handleDOMChanges() {
        setTimeout(() => {
            const datePicker = $(".booking-form .date-picker");
            if (datePicker.length) {
                datePicker.prepend($(".date-picker-select span"));
            }

            $(".booking-form input, .booking-form textarea, .booking-form .date-picker-input").each(function() {
                const span = $(this).siblings("span");
                if ($(this).val()) span.addClass("inputFocus");

                $(this).on('focus', () => span.addClass("inputFocus"))
                       .on('focusout', () => {
                           if (!$(this).val()) span.removeClass("inputFocus");
                       });
            });

            if ($(".date-picker-input").length) birthDateWhatcher();
        }, 50);
    }

    function birthDateWhatcher() {
        const label = $(".date-picker-input").parent().siblings(".label");
        $(".date-picker-input").val() ? label.addClass("inputFocus") : label.removeClass("inputFocus");
    }

    function observeContainer(container) {
        if (!container) return;

        new MutationObserver(handleDOMChanges).observe(container, {
            childList: true,
            subtree: true
        });

        handleDOMChanges();
    }

    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            $(mutation.addedNodes).each(function() {
                const container = $(this).is('.container--main') ? this : $(this).find('.container--main')[0];
                if (container) observeContainer(container);
            });
        });
    }).observe(document.body, { childList: true, subtree: true });

    observeContainer(document.querySelector('.container--main'));
});
